import React, { memo } from 'react';
import cls from './WeeksModeHeader.module.css';
import classNames from 'classnames';
import moment from 'moment';
import { addMoreWeeks } from '../../../../../../helpers/getDays';
import { useInfiniteScrollNew } from 'shared/hooks/useInfinityScrollNew';
import { useDispatch, useSelector } from 'react-redux';
import { gantActions } from '../../../../../../store/reducers/gantSlice/gantSlice';

export const WeeksModeHeader = memo(() => {
    const { weeks } = useSelector((state) => state.gantReducer);
    const dispatch = useDispatch();

    const last = weeks[weeks.length - 1];

    const onLoadNextPartLast = () => {
        if (last) {
            const current = last.dataDays;
            const newWeeks = addMoreWeeks(current, 'last');
            dispatch(gantActions.setWeeks([...weeks, ...newWeeks]));
        }
    };

    const lastElementRef = useInfiniteScrollNew(onLoadNextPartLast);

    if (weeks.length === 0) return null;

    const lastWeek = last.dataDays;
    const triggerLastWeek = moment(lastWeek, 'MM.YYYY').subtract(3, 'months').format('MM.YYYY');

    const nowDate = moment().format('DD.MM.YYYY');

    return (
        <div className={classNames(cls.DaysModeHeader)}>
            {weeks.map((week) => (
                <div className={classNames(cls.yearsWrapper)} key={Math.random().toString(36)}>
                    <div className={classNames(cls.month)}>{week.title}</div>
                    <div className={classNames(cls.weeks)}>
                        {week.weeks.map((item) => (
                            <div
                                key={item.title + Math.random().toString(36)}
                                className={classNames(cls.week)}
                            >
                                <span className={cls.title}>{item.title}</span>

                                {item.days.map((day) => (
                                    <div
                                        key={day}
                                        data-date={moment(day, 'DD.MM.YYYY').format()}
                                        data-date-now={day === nowDate}
                                        style={{ width: 11 }}
                                        className={classNames({
                                            [cls.nowDate]: day === nowDate,
                                        })}
                                    ></div>
                                ))}
                            </div>
                        ))}
                        {week.dataDays === triggerLastWeek && <div ref={lastElementRef}></div>}
                    </div>
                </div>
            ))}
        </div>
    );
});
